"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    RocketLaunch: function() {
        return RocketLaunch;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const RocketLaunch = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10.7377 6C13.2238 2.92171 17.0217 1 21.1981 1H22C22.5523 1 23 1.44772 23 2V2.80196C23 6.97833 21.0783 10.7762 18 13.2623V13.901C18 17.3425 15.5709 20.3056 12.1961 20.9806C11.6546 21.0889 11.1278 20.7377 11.0194 20.1961C11.0049 20.1233 10.9986 20.0507 11 19.9794V15.4142L8.58581 13H4.02067C3.95834 13.0012 3.89506 12.9966 3.83149 12.9857C3.81277 12.9825 3.79417 12.9788 3.77573 12.9745C3.49989 12.9112 3.27593 12.7384 3.14078 12.5116C3.01846 12.3063 2.96889 12.0567 3.01945 11.8039C3.69439 8.42917 6.6575 6 10.099 6H10.7377ZM9.37242 8.05047C7.61863 8.29587 6.11715 9.41736 5.3741 11H8.2058C8.48111 9.95788 8.87551 8.97017 9.37242 8.05047ZM10.0958 11.6815L12.3185 13.9042C17.3321 12.6611 20.9087 8.19339 20.9983 3.00172C15.8066 3.09135 11.3389 6.66796 10.0958 11.6815ZM13 15.7942V18.6259C14.5827 17.8829 15.7042 16.3814 15.9496 14.6276C15.0299 15.1245 14.0421 15.5189 13 15.7942ZM13.5 8C13.5 6.61929 14.6193 5.5 16 5.5C17.3807 5.5 18.5 6.61929 18.5 8C18.5 9.38071 17.3807 10.5 16 10.5C14.6193 10.5 13.5 9.38071 13.5 8ZM16 8.5C16.2762 8.5 16.5 8.27614 16.5 8C16.5 7.72386 16.2762 7.5 16 7.5C15.7239 7.5 15.5 7.72386 15.5 8C15.5 8.27614 15.7239 8.5 16 8.5ZM5.67547 17C5.10534 17 4.59918 17.3648 4.41889 17.9057L3.58117 20.4189L6.09433 19.5811C6.6352 19.4008 7.00003 18.8947 7.00003 18.3246C7.00003 17.593 6.407 17 5.67547 17ZM5.67547 15C7.51157 15 9.00003 16.4885 9.00003 18.3246C9.00003 19.7555 8.08434 21.026 6.72679 21.4785L2.31625 22.9487C1.95692 23.0685 1.56075 22.9749 1.29292 22.7071C1.02509 22.4393 0.931566 22.0431 1.05134 21.6838L2.52152 17.2732C2.97404 15.9157 4.24448 15 5.67547 15Z",
        fill: "currentColor"
    })
}), "RocketLaunch");
const _default = RocketLaunch;
